// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-1V3HM";
var _3 = "promo-1WC6J";
var _4 = "promo__image-UosII";
var _5 = "promo__icon-1qpkC";
export { _1 as "__esModule", _2 as "wrapper", _3 as "promo", _4 as "promo__image", _5 as "promo__icon" }
export default { "__esModule": _1, "wrapper": _2, "promo": _3, "promo__image": _4, "promo__icon": _5 }
